import React, {useEffect, useState} from "react";
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export const Navigation = () => {
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const [isScrolled, setIsScrolled] = useState(false);
  const getLang = localStorage.getItem('lng');
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  const closeMobileNav = () => {
    setIsMobileNavOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50); // Change 50 to adjust scroll threshold
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const changeLang = (e) => {
    const lng = e.target.value;
    if (lng) {
      localStorage.setItem('lng', lng);
      i18n.changeLanguage(lng);
      setIsMobileNavOpen(false);
    }
  }

  useEffect(() => {
    const currentUrl = window.location.href;
    const splitUrl = currentUrl.split("#");
    if (splitUrl[1]) {
      setTimeout(() => {
       history.push(`/${getLang}#${splitUrl[1]}`);
      }, 100); 
    }
}, [ getLang, history]);

  return (
    <nav id="menu" className={`navbar navbar-default navbar-fixed-top ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container nav-cont">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            onClick={toggleMobileNav}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <img src="img/logo.png" alt="logo"/>
          </a>
        </div>

        <div
          className={`collapse navbar-collapse ${isMobileNavOpen ? 'in' : ''}`}
          id="navbar-collapse"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll" onClick={closeMobileNav}>
                {t('about.title')}
              </a>
            </li>
            <li>
              <a href="#partners" className="page-scroll" onClick={closeMobileNav}>
                {t('partners.title')}
              </a>
            </li>
            <li>
              <a href="#media" className="page-scroll" onClick={closeMobileNav}>
                {t('media.title')}
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeMobileNav}>
                {t('contact.title')}
              </a>
            </li>
            <li>
              <select className="select-lng" onChange={changeLang} value={getLang}>
                <option value="en">Eng</option>
                <option value="hy" defaultValue={true}>Հայ</option>
              </select>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
